/**
 * File: IconLabel.js
 * Origin: isotect
 * Description: [TODO: Description]
 *
 * Version: v1.0.1
 * Created: 2025-07-27
 * Last Updated: 2026-04-23
 *
 * Used By: isotect
 * Maintainer: Zachary Dicks
 *
 * Notes:
 * - Changes in this file may affect all consuming frontend modules.
 * - See Git repository 'isotect' for full change history.
 */

import { Link } from "react-router-dom";

/**
 * [TODO: Component description here]
 *
 * @param {Object} props - Component properties
 * @returns {JSX.Element} [TODO: Rendered output]
 */
function IconLabel({ icon, text }) {
    return (
        <>
            <div className="icon-label">
                {icon}
                <p>{text}</p>
            </div>
        </>
    );
}

export default IconLabel;
